import { MotifFooter } from "@ey-xd/motif-react";
import eyFooterLogo from "../../assets/images/footer_logo.svg";
import "./Footer.scss";

const Footer: React.FC = () => {
  return (
    <MotifFooter className="footer-section">
      <div>
        <img src={eyFooterLogo} alt="ey-logo"/>
      </div>
      <div className="footer-sub-section">
        <a
          href="https://www.ey.com/en_gl/legal-and-privacy/privacy-statement"
          target="_blank"
          className="footer-privacy-statement"
        >
          Privacy Statement
        </a>
        <p className="footer-text">
          © 2026 EYGM Limited | All Rights Reserved.
        </p>
        <p className="footer-text">
          Content within this application is confidential and meant for EY staff
          only.
        </p>
      </div>
    </MotifFooter>
  );
};
export default Footer;
